import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { CombinedSearchTermsConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { CombinedSearchTermsData, CombinedSearchTermDataPoint } from "app/shared/model/manualsanalyticsdata.model";

@Component({
  selector: "combined-search-terms-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class CombinedSearchTermsChartComponent
  extends BaseChartLogic<CombinedSearchTermsConfig, CombinedSearchTermsData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      CombinedSearchTermsConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.combinedSearchTermsDataChange);
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(dataPoint: CombinedSearchTermDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.FilterByMinimum = this.config?.minUsed || null;
  }

  refreshData(): void {
    this.analyticsService.getCombinedSearchTermsData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}